import { Grid, Typography, Select, Checkbox, MenuItem, Box } from '@material-ui/core';
import { Check, ArrowDropDown } from '@material-ui/icons';
import React, { useState } from 'react';
import { useCampfireTheme } from '../../../../../../../theme/useCampfireTheme';
import { BorderSelectInput, useFilterStyles } from '../../../../../../../common/filter-fields/FilterClasses';
import { sortFilters, IncomingVolunteersSelectFieldProps } from '../filters';

export const SortSelectField = ({ selectedFilters, setSelectedFilters }: IncomingVolunteersSelectFieldProps) => {
  const [popoverOpen, setPopoverOpen] = useState<boolean>(false);
  const { theme } = useCampfireTheme();
  const classes = useFilterStyles(theme);
  const isSortFilterSelected = (value: string) => selectedFilters.selectedSortFilter === value;

  const handleStatusChange = (event: EventTarget & any) =>
    setSelectedFilters({
      ...selectedFilters,
      selectedSortFilter: event.target.value,
    });

  return (
    <Grid item className={classes.subheaderGridItem}>
      <Select
        displayEmpty
        open={popoverOpen}
        onOpen={() => setPopoverOpen(true)}
        onClose={() => setPopoverOpen(false)}
        input={<BorderSelectInput status={'active'} />}
        IconComponent={() => (
          <Box display='flex' alignItems='center' onClick={() => setPopoverOpen(true)} style={{ cursor: 'pointer' }}>
            <ArrowDropDown style={{ fill: theme.palette.primary.main }} />
          </Box>
        )}
        renderValue={() => selectedFilters.selectedSortFilter}
        onChange={handleStatusChange}
        value={selectedFilters.selectedSortFilter}
      >
        {sortFilters.map((filter) => (
          <MenuItem key={filter} value={filter} className={classes.menuItem}>
            <Typography
              variant='body2'
              style={isSortFilterSelected(filter) ? { fontWeight: 600 } : { fontWeight: 'normal' }}
            >
              {filter}
            </Typography>
            <Checkbox
              checked={isSortFilterSelected(filter)}
              className={classes.checkBoxSelectField}
              checkedIcon={<Check color='primary' width={12} />}
              icon={<span className={classes.icon} />}
              disableRipple
            />
          </MenuItem>
        ))}
      </Select>
    </Grid>
  );
};
